import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Organization } from '../../models';
import { TeamDataService, OrganizationDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TeamForm } from './TeamForm';
import { UserStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface TeamCreateState {
    organizations: Organization[];
}

interface TeamCreateProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
}

@inject('UserStore') @observer
export class TeamCreate extends React.Component<TeamCreateProps, TeamCreateState> {
    private teamDataService = new TeamDataService(this.props.notificationService);
    private organizationDataService = new OrganizationDataService(this.props.notificationService);

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get organization() {
        return this.props.UserStore!.userInfo.organization;
    }

    constructor(props: TeamCreateProps) {
        super(props);

        this.state = {
            organizations: new Array<Organization>()
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        if (['organizationAdmin', 'manager', 'user'].includes(this.userRole)) {
            this.organizationDataService.get(this.organization!.id).then((organization: Organization) => {
                this.setState({ organizations: [organization] });
            });
        } else {
            this.organizationDataService.getAll().then((organizations: Organization[]) => {
                this.setState({ organizations: organizations });
            });
        }
    }

    public render() {
        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            <NavLink to={`/team`}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp; 
                            Create Team
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <TeamForm UserStore={this.props.UserStore} submit={this.save} organizations={this.state.organizations} notificationService={this.props.notificationService} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.teamDataService.create(values).then((success) => {
            this.props.history.push('/team');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/team/TeamCreate.tsx